import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lightning14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.24544 1.08276L8.83798 4.74994H12C12.6297 4.74994 12.9792 5.51532 12.5668 5.99113L6.0668 13.4911C5.59591 14.0345 4.67522 13.6317 4.75462 12.9171L5.16208 9.24994H2.00003C1.37038 9.24994 1.02089 8.48456 1.43326 8.00874L7.93326 0.508739C8.40415 -0.0345934 9.32484 0.368168 9.24544 1.08276ZM3.6425 7.74994H6.83798L6.51157 10.6876L10.3576 6.24994H7.16208L7.48849 3.31226L3.6425 7.74994Z'
      fill='currentColor'
    />
  </Svg>
);

Lightning14.displayName = 'Lightning14';
export default Lightning14;
